import type BaseModel from "./BaseModel";
import type BaseModelReference from "./BaseModelReference";
import { enumCompareStatus } from "./BaseObject";

export default class TreeNodeInfo {
  obj: BaseModel;
  referencedObj: BaseModel | undefined;

  _parentNode: WeakRef<TreeNodeInfo> | undefined;

  get isTreeNodeInfo(): boolean {
    return true;
  }

  set parentTreeNodeInfo(value: TreeNodeInfo | undefined) {
    if (value) {
      this._parentNode = new WeakRef(value);
    } else {
      this._parentNode = undefined;
    }
  }

  get parentTreeNodeInfo(): TreeNodeInfo | undefined {
    return this._parentNode?.deref();
  }

  get isReference(): boolean {
    return this.referencedObj != undefined;
  }

  get isDeleted(): boolean {
    if (this.obj.compareStatus & enumCompareStatus.deletedInCurrentProject || this.obj.isDeleted) {
      return true;
    }
    return this.parentIsDeleted;
  }

  get parentIsDeleted(): boolean {
    return this.parentTreeNodeInfo?.isDeleted || false;
  }

  // get isDeletedInOtherProject(): boolean {
  //   if (this.obj.compareStatus & enumCompareStatus.deletedInOtherProject) {
  //     return true;
  //   }
  //   return this.parentIsDeletedInOtherProject;
  // }

  // get parentIsDeletedInOtherProject(): boolean {
  //   return this.parentTreeNodeInfo?.isDeletedInOtherProject || false;
  // }

  // get isNew(): boolean {
  //   if (this.obj.compareStatus & enumCompareStatus.deletedInOtherProject) {
  //     return true;
  //   }
  //   return this.parentIsDeletedInOtherProject;
  // }

  // get parentIsNew(): boolean {
  //   return this.parentTreeNodeInfo?.isDeletedInOtherProject || false;
  // }

  // get isNewInOtherProject(): boolean {
  //   if (this.obj.compareStatus & enumCompareStatus.deletedInOtherProject) {
  //     return true;
  //   }
  //   return this.parentIsDeletedInOtherProject;
  // }

  // get parentIsNewInOtherProject(): boolean {
  //   return this.parentTreeNodeInfo?.isDeletedInOtherProject || false;
  // }

  hasCompareStatus(status: enumCompareStatus): boolean {
    if (status == enumCompareStatus.equal) {
      return (
        !this.parentHasCompareStatus(
          enumCompareStatus.deletedInOtherProject |
            enumCompareStatus.deletedInCurrentProject |
            enumCompareStatus.newInCurrentProject |
            enumCompareStatus.newInOtherProject,
        ) && this.obj.compareStatus == enumCompareStatus.equal
      );
    }

    if (this.obj.compareStatus & status) {
      return true;
    }
    return this.parentHasCompareStatus(status);
  }

  parentHasCompareStatus(status: enumCompareStatus): boolean {
    if (status == enumCompareStatus.equal) {
      return this.parentTreeNodeInfo?.hasCompareStatus(status) ?? true;
    }
    return this.parentTreeNodeInfo?.hasCompareStatus(status) || false;
  }

  constructor(parentNode: TreeNodeInfo | undefined, obj: BaseModel, referencedObj?: BaseModel) {
    this.obj = obj;
    this.referencedObj = referencedObj;
    this.parentTreeNodeInfo = parentNode;
  }

  isChildOf(treeviewModelOrObj: TreeNodeInfo | BaseModel | undefined): boolean {
    if (treeviewModelOrObj) {
      let o = this.parentTreeNodeInfo;
      while (o) {
        if (o == treeviewModelOrObj) {
          return true;
        } else if (o?.isTreeNodeInfo) {
          if (o.obj == treeviewModelOrObj) {
            return true;
          } else {
            if (o.obj.className == "BaseModelReference") {
              const ref = o.obj as BaseModelReference;
              if (ref.referencedObject == treeviewModelOrObj) {
                return true;
              }
            }
          }
        }

        o = o.parentTreeNodeInfo;
      }
    }
    return false;
  }
}
